import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions('App', ['setCrumbs',]),
    },
}